module.exports = __webpack_public_path__ + "fe05cd6bf1f1c9adaf62a0aaa711005b.MP3";